import { TableBody, TableItem, Tooltip, Button, SuitabilityBadge } from '@genial/components';
import { Spacing, Typography } from '@genial/design-tokens';
import { Text, Box } from 'native-base';
import React from 'react';

import { rowHeight, widthCols } from '../constants';
import { TableItemProps } from '../models';

import { CustomerBlockStatus } from './components/CustomerBlockStatus';
import { IconCustomerList } from './components/IconCustomerList';

const DesktopTableItemBase = ({ customerCaption, handleSelectCustomer, item }: TableItemProps) => {
  return (
    <TableBody testId={`table-customer-body-${item.cpfCnpjFormatted}`} height={rowHeight.desktop}>
      <TableItem testId="table-customer-name" width={widthCols.name}>
        <Tooltip testId="qa" label={item.name}>
          <Text
            numberOfLines={2}
            lineHeight={'18px'}
            variant="regular"
            {...(customerCaption.length > 0 && {
              mb: Spacing['inline.quarck'],
            })}
            fontSize={Typography['fontsize.xs']}>
            {item.name}
          </Text>
        </Tooltip>
        {customerCaption.length > 0 && <IconCustomerList icons={customerCaption} />}
      </TableItem>
      <TableItem testId="table-customer-account-number" width={widthCols.custodyAccountNumber}>
        {item.custodyAccountNumber}
      </TableItem>
      <TableItem
        testId="table-customer-suitability-profile-name"
        width={widthCols.suitabilityProfileName}>
        <SuitabilityBadge label={item.suitabilityProfileName} />
      </TableItem>
      <TableItem testId="table-customer-cpf-cnpj-formatted" width={widthCols.cpfCnpjFormatted}>
        {item.cpfCnpjFormatted}
      </TableItem>
      <TableItem
        testId="table-customer-registration-status-name"
        width={widthCols.registrationStatusName}>
        <CustomerBlockStatus customer={item} />
      </TableItem>
      <TableItem testId="table-customer-available-balance" width={widthCols.availableBalance}>
        {item.availableBalance}
      </TableItem>
      <TableItem
        testId="table-customer-button-select-customer"
        width={widthCols.buttonSelectCustomer}
        align="end">
        <Box w={'100%'}>
          <Button
            testID="table-customer-button-select-customer"
            onPress={handleSelectCustomer}
            isDisabled={item.registrationBlocked}>
            {item.buttonSelectCustomer}
          </Button>
        </Box>
      </TableItem>
    </TableBody>
  );
};

export const DesktopTableItem = React.memo(DesktopTableItemBase);
